module.exports = __webpack_public_path__ + "static/media/facebook.a7afbc90.png";